import { bool, object, string } from "prop-types"
import { Icon } from "@planningcenter/tapestry-react"

const ViewOnChurchCenterButton = ({
  archived,
  churchCenterUrl,
  ccwRef,
  ccwRegistrationsPublished,
  ccwEnabled,
  styles
}) => {
  const handleClick = e => e.stopPropagation()

  return ccwRegistrationsPublished && ccwEnabled && !archived ? (
    <a
      href={churchCenterUrl}
      className="btn-outline interaction"
      css={styles}
      title="View on Church Center"
      target="_blank"
      rel="noreferrer"
      ref={ccwRef}
      onClick={handleClick}
    >
      <Icon size="lg" name="general.newWindow" />
    </a>
  ) : null
}

ViewOnChurchCenterButton.propTypes = {
  archived: bool,
  churchCenterUrl: string,
  ccwRef: string,
  ccwRegistrationsPublished: bool,
  ccwEnabled: bool,
  styles: object
}

export default ViewOnChurchCenterButton
